import { render, staticRenderFns } from "./CustomQuestionOption.vue?vue&type=template&id=ca7f89d4&scoped=true"
import script from "./CustomQuestionOption.vue?vue&type=script&lang=ts"
export * from "./CustomQuestionOption.vue?vue&type=script&lang=ts"
import style0 from "./CustomQuestionOption.vue?vue&type=style&index=0&id=ca7f89d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7f89d4",
  null
  
)

export default component.exports